import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class TranslationMenu extends React.Component {
    renderState() {
        if (this.props.translationInProgress) {
            return (
                <span className="save-indicator save-indicator--saving">
                    <FormattedMessage id="brief_translating" />
                </span>
            );
        } else if (this.props.translationFailed) {
            return (
                <span className="save-indicator save-indicator--error">
                    <FormattedMessage id="brief_translation_failed" />
                </span>
            );
        }
    }

    render() {
        const changeLanguage = event => {
            this.props.onChangeLanguage(event.target.value);
        };

        return (
            <div className="field field--with-save-indicator">
                <div className="field__save-indicator">{this.renderState()}</div>
                <label className="field__title" htmlFor="translate_to">
                    <FormattedMessage id="brief_translation_title" />
                </label>
                <div className="field__input">
                    <span className="select select--full-width">
                        <select
                            name="translate_to"
                            id="translate_to"
                            value={this.props.selectedLanguageKey}
                            onChange={changeLanguage}
                        >
                            {this.props.languages.map(language => {
                                return (
                                    <option key={language.key} value={language.key}>
                                        {language.title}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                </div>
            </div>
        );
    }
}

TranslationMenu.propTypes = {
    languages: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        })
    ).isRequired,
    selectedLanguageKey: PropTypes.string.isRequired,
    onChangeLanguage: PropTypes.func.isRequired,
    translationInProgress: PropTypes.bool,
    translationFailed: PropTypes.bool,
};

TranslationMenu.defaultProps = {
    translationInProgress: false,
    translationFailed: false,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/translation-menu.jsx